import { render, staticRenderFns } from "./Podopediatrie.vue?vue&type=template&id=7ed3387e&"
import script from "./Podopediatrie.vue?vue&type=script&lang=js&"
export * from "./Podopediatrie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports